import { Reducer } from "redux";
import { StudentRoomAssignmentState } from "./types";
import { StudentRoomAssignmentActionTypes } from "./actions";

const initialState: StudentRoomAssignmentState = {
  isAssigning: false,
  isUnassigning: false,
  isLoadingStudents: false,
  success: false,
  failure: false,
  error: null,
  studentsInRoom: [],
  assignedStudent: null,
  unassignedStudent: null,
};

const reducer: Reducer<StudentRoomAssignmentState> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case StudentRoomAssignmentActionTypes.ASSIGN_STUDENT_REQUEST:
      return {
        ...state,
        isAssigning: true,
        success: false,
        failure: false,
        error: null,
      };
    case StudentRoomAssignmentActionTypes.ASSIGN_STUDENT_SUCCESS:
      return {
        ...state,
        isAssigning: false,
        success: true,
        failure: false,
        assignedStudent: action.payload,
      };
    case StudentRoomAssignmentActionTypes.ASSIGN_STUDENT_ERROR:
      return {
        ...state,
        isAssigning: false,
        success: false,
        failure: true,
        error: action.payload,
      };
    case StudentRoomAssignmentActionTypes.UNASSIGN_STUDENT_REQUEST:
      return {
        ...state,
        isUnassigning: true,
        success: false,
        failure: false,
        error: null,
      };
    case StudentRoomAssignmentActionTypes.UNASSIGN_STUDENT_SUCCESS:
      return {
        ...state,
        isUnassigning: false,
        success: true,
        failure: false,
        unassignedStudent: action.payload,
      };
    case StudentRoomAssignmentActionTypes.UNASSIGN_STUDENT_ERROR:
      return {
        ...state,
        isUnassigning: false,
        success: false,
        failure: true,
        error: action.payload,
      };
    case StudentRoomAssignmentActionTypes.GET_STUDENTS_IN_ROOM_REQUEST:
      return {
        ...state,
        isLoadingStudents: true,
        error: null,
      };
    case StudentRoomAssignmentActionTypes.GET_STUDENTS_IN_ROOM_SUCCESS:
      return {
        ...state,
        isLoadingStudents: false,
        studentsInRoom: action.payload,
      };
    case StudentRoomAssignmentActionTypes.GET_STUDENTS_IN_ROOM_ERROR:
      return {
        ...state,
        isLoadingStudents: false,
        error: action.payload,
      };
    case StudentRoomAssignmentActionTypes.CLEAR_ASSIGNMENT_STATE:
      return initialState;
    default:
      return state;
  }
};

export default reducer;
